import { AxiosError, AxiosResponse } from 'axios';
import instance, { ApiError } from 'src/api/instance';
import {
  CompanyWifi,
  CompanyWifiCreate,
  CompanyWifiUpdate,
  CompanyWifiListResponse,
  CompanyWifiDeleteResponse,
} from './wifi.types';

const companyWifiPath = (companyId: string) => `/companies/${companyId}/wifi`;

export const getWifiList = async ({
  companyId,
}: {
  companyId: string;
}): Promise<AxiosResponse<CompanyWifiListResponse>> => {
  return instance.get(companyWifiPath(companyId)).catch(e => e.response as AxiosError<ApiError> as never);
};

export const createWifi = async ({ companyId, data }: { companyId: string; data: CompanyWifiCreate }) => {
  return instance
    .post<CompanyWifi>(companyWifiPath(companyId), data)
    .catch(e => e.response as AxiosError<ApiError> as never);
};

export const updateWifi = async ({ companyId, data }: { companyId: string; data: CompanyWifiUpdate }) => {
  return instance
    .put<CompanyWifi>(companyWifiPath(companyId), data)
    .catch(e => e.response as AxiosError<ApiError> as never);
};

export const deleteWifi = async ({
  companyId,
  wifiId,
}: {
  companyId: string;
  wifiId: string;
}): Promise<AxiosResponse<CompanyWifiDeleteResponse>> => {
  return instance
    .delete(companyWifiPath(companyId), { data: { wifi_id: wifiId } })
    .catch(e => e.response as AxiosError<ApiError> as never);
};
